import { render, staticRenderFns } from "./DoctorCardB.vue?vue&type=template&id=6cdfd5cb&scoped=true"
import script from "./DoctorCardB.vue?vue&type=script&lang=js"
export * from "./DoctorCardB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdfd5cb",
  null
  
)

export default component.exports